export const ADMIN_SUSPEND_ACCOUNT_MODAL = 'ADMIN_SUSPEND_ACCOUNT_MODAL';
export const TEAM_INVITE_MODAL = 'TEAM_INVITE_MODAL';
export const AUTOJOIN_MODAL = 'AUTOJOIN_MODAL';
export const CSV_UPLOAD_MODAL = 'CSV_UPLOAD_MODAL';
export const PRIVACY_CHANGE_CONFIRMATION_MODAL =
  'PRIVACY_CHANGE_CONFIRMATION_MODAL';
export const PRIVACY_CHANGE_MOVE_CONFIRMATION_MODAL =
  'PRIVACY_CHANGE_MOVE_CONFIRMATION_MODAL';
export const ADMIN_DELETE_ACCOUNT_WARNING_MODAL =
  'ADMIN_DELETE_ACCOUNT_WARNING_MODAL';
export const INVITE_INCENTIVE_TERMS_MODAL = 'INVITE_INCENTIVE_TERMS_MODAL';
export const TRANSFER_LIBRARY_SELECTION_CONFIRMATION =
  'TRANSFER_LIBRARY_SELECTION_CONFIRMATION';
export const LEAVE_WORKSPACE_CONFIRMATION = 'LEAVE_WORKSPACE_CONFIRMATION';
export const CHECKLIST_RECORD_BUTTON_MODAL = 'CHECKLIST_RECORD_BUTTON_MODAL';
export const DOWNLOAD_VIDEO_INFO_MODAL = 'DOWNLOAD_VIDEO_INFO_MODAL';

export const SHARE_UI_MODAL = 'SHARE_UI_MODAL';
export const ADD_LOOM_SEARCH_MODAL = 'ADD_LOOM_SEARCH_MODAL';
export const SIGNUP_MODAL = 'SIGNUP_MODAL';
export const FORGOT_PASSWORD_MODAL = 'FORGOT_PASSWORD_MODAL';
export const VERIFY_EMAIL_MODAL = 'VERIFY_EMAIL_MODAL';
export const REQUEST_UPGRADE_MODAL = 'REQUEST_UPGRADE_MODAL';
export const DATA_RETENTION_PREVIEW_MODAL = 'DATA_RETENTION_PREVIEW_MODAL';
export const WORKSPACE_SELECTOR_MODAL = 'WORKSPACE_SELECTOR_MODAL';
export const CREATE_NEW_WORKSPACE_MODAL = 'CREATE_NEW_WORKSPACE_MODAL';
export const CONFIRM_DELETE_ITEM_MODAL = 'CONFIRM_DELETE_ITEM_MODAL';
export const SUGGEST_PUBLISHING_PROMPT = 'SUGGEST_PUBLISHING_PROMPT';

export const SHARE_RECORD_REPLY_SIGNUP_MODAL =
  'SHARE_RECORD_REPLY_SIGNUP_MODAL';
export const ANON_CREATOR_SIGNUP_MODAL = 'ANON_CREATOR_SIGNUP_MODAL';

export const DESTINATION_SEARCH_MODAL = 'DESTINATION_SEARCH_MODAL';
export const DESTINATION_MOVE_MODAL = 'DESTINATION_MOVE_MODAL';
export const EDIT_PROFILE_MODAL = 'EDIT_PROFILE_MODAL';
export const CONTACT_SUPPORT_MODAL = 'CONTACT_SUPPORT_MODAL';
export const CONTACT_SUPPORT_CONFIRMATION_MODAL =
  'CONTACT_SUPPORT_CONFIRMATION_MODAL';
export const UNPUBLISH_VIDEO_CONFIRMATION_MODAL =
  'UNPUBLISH_VIDEO_CONFIRMATION_MODAL';
export const WORKSPACE_CONTACTS_MODAL = 'WORKSPACE_CONTACTS_MODAL';
export const WORKSPACE_CONTACTS_CONFIRMATION_MODAL =
  'WORKSPACE_CONTACTS_CONFIRMATION_MODAL';
export const PUBLISH_MOVE_CONFIRMATION_MODAL =
  'PUBLISH_MOVE_CONFIRMATION_MODAL';
export const SDK_RECORDING_LOADING_MODAL = 'SDK_RECORDING_LOADING_MODAL';
export const UNPUBLISH_FOLDER_CONFIRMATION_MODAL =
  'UNPUBLISH_FOLDER_CONFIRMATION_MODAL';
export const ANON_CREATOR_CLAIM_MODAL = 'ANON_CREATOR_CLAIM_MODAL';
